import React from "react";
import * as api from '../../api/facility'
import PageList from '../../components/PageListAPI'

// добавить создание удаление
export default function FacilityAccessById(props) {
  return <div className='App-paper'>
    <PageList
      name='facility'
      title='Список доступных проектов'
      columns={[
        { id: 'name', name: 'Наименование' },
      ]}
      createItem={false}
      deleteItem={false}
      idName='id'
      loadAPI={{
        param: {
          idFacility: props.match.params.id,
          idUser: props.match.params.idUser,
        },
        request: api.getFacilityAccessById,
        transform: res => {
          return { ...res, get: res.get.map(e => ({ ...e, allRu: e.all ? 'Да' : 'Нет' })) }
        }
      }
      }
      click={false}
      // deleteAPI={api.delFacilityAccess(props.match.params.id)}
      {...props}
    />
  </div>
}